module.exports = __webpack_public_path__ + "static/media/cameraSelfieMaskDesktop.fba0dd5e.png";